import { HeroSection, Section, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { SKELETON_CLASSNAME } from '../base/constants';
import OrdersList from './components/OrdersList';

export default function OrdersPage() {
  const { language, t } = useTranslation();
  const skeletonClassname = language ? '' : SKELETON_CLASSNAME;
  const title = language ? t('manage:Orders.Title') : '';

  return (
    <div data-testid="orders">
      <HeroSection lottie={'brain'} lottieAuto={true} lottieLoop={true}>
        <SectionTitle className={skeletonClassname}>{title}</SectionTitle>
      </HeroSection>
      <Section>
        <OrdersList />
      </Section>
    </div>
  );
}
